import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_RANKING_EXPORTADORES } from '../../../../config/tables'

export default function RankingExportadoresView () {
  return <MuiTable id={TABLA_RANKING_EXPORTADORES} />
}
